import { useDeviationAttributes } from '../../../DeviationViews/hooks/useDeviationAttributes';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { useSelector } from 'react-redux';
import { getIsCurrentUserAuthorOf } from '../../../redux/deviations/selectors';
export function useIsAddToGroupInMoreMenu(deviation) {
    const isAdoptablesFlagEnabled = useFlag('adoptables');
    const isAddToGroupInDropdownFlagEnabled = useFlag('add_to_group_in_dropdown_desktop');
    const isOwner = useSelector((state)=>getIsCurrentUserAuthorOf(state, deviation));
    const isAnAdoptable = deviation.isAdoptable && isAdoptablesFlagEnabled;
    const { isGroupSubmittable  } = useDeviationAttributes(deviation, isOwner);
    return (isAnAdoptable || isAddToGroupInDropdownFlagEnabled && !isOwner) && isGroupSubmittable;
}
